import { EQuizMode } from '@constants';

export const StudentQuizHistoryTranslations = {
  QUIZ_HISTORY: {
    es: 'Historial de exámenes',
    en: 'Quiz History',
    cat: 'Historial de quizzes',
    eus: 'Quiz historia',
    pt: 'Histórico de quizzes'
  },
  QUIZ_RESULT_SORTER: {
    es: 'Ordenar por:',
    en: 'Sort by:',
    cat: 'Ordenar per:',
    eus: 'Eskubidez:',
    pt: 'Ordenar por:'
  },
  QUIZ_RESULT_COUNT: {
    es: '{{count}} tests',
    en: '{{count}} tests',
    cat: '{{count}} tests',
    eus: '{{count}} tests',
    pt: '{{count}} tests'
  },
  CREATED_AT_SORT: {
    es: 'Fecha más reciente',
    en: 'Latest date',
    cat: 'Data més recent',
    eus: 'Azken data',
    pt: 'Data mais recente'
  },
  TOP_SCORE_SORT: {
    es: 'Resultado más alto',
    en: 'Highest score',
    cat: 'Resultat més alt',
    eus: 'Eskubide mairuena',
    pt: 'Resultado mais alto'
  },
  MIN_SCORE_SORT: {
    es: 'Resultado más bajo',
    en: 'Lowest score',
    cat: 'Resultat més baix',
    eus: 'Eskubide txikiena',
    pt: 'Resultado mais baixo'
  },
  [EQuizMode.QUIZ]: {
    es: '🎯 Quiz',
    en: '🎯 Quiz',
    cat: '🎯 Quiz',
    eus: '🎯 Quiz',
    pt: '🎯 Quiz'
  },
  [EQuizMode.PRACTICE]: {
    es: '⏳ Simulacro',
    en: '⏳ Simulator',
    cat: '⏳ Simulacre',
    eus: '⏳ Simulazio',
    pt: '⏳ Simulador'
  },
  [EQuizMode.TRUE_FALSE]: {
    es: '🏓 Verdadero o Falso',
    en: '🏓 True or False',
    cat: '🏓 Veritat o Fals',
    eus: '🏓 Egia edo Derrus',
    pt: '🏓 Verdadeiro ou Falso'
  },
  [EQuizMode.PRACTICAL_CASE]: {
    es: '📋 Caso Práctico',
    en: '📋 Practical Case',
    cat: '📋 Cas Pràctic',
    eus: '📋 Praktike kasua',
    pt: '📋 Caso Prático'
  },
  [EQuizMode.LIGHTNING]: {
    es: '⚡️ Relámpago',
    en: '⚡️ Lightning',
    cat: '⚡️ Llit',
    eus: '⚡️ Iraupak',
    pt: '⚡️ Relâmpago'
  },
  VIEW_RESULTS: {
    es: 'Ver resultados',
    en: 'View results',
    cat: 'Veure resultats',
    eus: 'Ikusi emaitzak',
    pt: 'Ver resultados'
  },
  RETAKE_QUIZ: {
    es: 'Repetir test',
    en: 'Retake test',
    cat: 'Repetir test',
    eus: 'Errepikatu proba',
    pt: 'Repetir teste'
  },
  RETAKE_WRONGS: {
    es: 'Repetir incorrectas',
    en: 'Retake wrong ones',
    cat: 'Repetir incorrectes',
    eus: 'Errepikatu huts egin',
    pt: 'Repetir erradas'
  },
  RETAKE: {
    es: 'Repetir',
    en: 'Retake',
    cat: 'Repetir',
    eus: 'Errepikatu',
    pt: 'Repetir'
  },
  ALL_COURSES: {
    es: 'Todos los cursos',
    en: 'All courses',
    cat: 'Tots els cursos',
    eus: 'Guztira',
    pt: 'Todos os cursos'
  },

  RETRY_ERROR_TITLE: {
    es: 'Error',
    en: 'Error',
    cat: 'Error',
    eus: 'Errorea',
    pt: 'Erro'
  },

  RETRY_ERROR_MESSAGE: {
    es: 'Error al crear el test de repaso',
    en: 'Error creating the review test',
    cat: 'Error al crear el test de repaso',
    eus: 'Errorea egin duzu testuaren berreikin',
    pt: 'Erro ao criar o teste de revisão'
  }
};
